export default [
  {
    query: 'Avéne',
    suggestions: ['solare', 'hydrance', 'cleanance', 'tolerance', 'crema'],
  },
  {
    query: 'cerave',
    suggestions: [
      'detergente',
      'crema',
      'viso',
      'crema corpo',
      'detergente viso',
    ],
  },
  {
    query: 'bionike',
    suggestions: ['defence', 'fondotinta', 'triderm', 'defence sun', 'shampoo'],
  },
  {
    query: 'nuxe',
    suggestions: ['olio', 'reve de miel', 'labbra', 'profumo', 'huile'],
  },
  {
    query: 'la roche posay',
    suggestions: ['anthelios', 'effaclar', 'siero', 'toleriane', 'cicaplast'],
  },
  {
    query: 'RILASTIL',
    suggestions: ['viso', 'olio', 'acnestil', 'multirepair', 'xerolact'],
  },
  {
    query: 'Vitamina d',
    suggestions: ['metagenics', 'di base', '2000 ui', 'vitamina d3', '1000'],
  },
  {
    query: 'caudalie',
    suggestions: ['vinoperfect', 'vinopure', 'siero', 'crema viso', 'acqua'],
  },
  {
    query: 'bioscalin',
    suggestions: ['shampoo', 'compresse', 'energy', 'nutricolor', 'fiale'],
  },
  {
    query: 'vichy',
    suggestions: [
      'deodorante',
      'normaderm',
      'liftactiv',
      'mineral 89',
      'crema',
    ],
  },
  {
    query: 'cerotti',
    suggestions: ['nasali', 'medicati', 'vesciche', 'bambini', 'grandi'],
  },
  {
    query: 'collirio',
    suggestions: [
      'monodose',
      'alfa',
      'acido ialuronico',
      'idratante',
      'systane',
    ],
  },
  {
    query: 'eucerin',
    suggestions: [
      'anti pigment',
      'urea',
      'atopica atopicontrol',
      'crema viso',
      'crema',
    ],
  },
  {
    query: 'named',
    suggestions: [
      'sport',
      'namedsport proteine',
      'namedsport srl',
      'whey',
      'namedsport gel',
    ],
  },
  {
    query: 'vitamina C',
    suggestions: ['1000', 'siero', 'longlife', 'pura', 'solgar'],
  },
  {
    query: 'magnesio',
    suggestions: ['supremo', 'e potassio', '2', 'completo', 'compresse'],
  },
  {
    query: 'caudalie',
    suggestions: ['vinoperfect', 'vinopure', 'siero', 'crema viso', 'acqua'],
  },
  {
    query: 'fermenti lattici',
    suggestions: ['compresse', 'capsule', 'flaconcini', 'vivi', 'probiotica'],
  },
  {
    query: 'Somatoline',
    suggestions: ['7 notti', 'cellulite', 'deodorante', 'viso', 'uomo'],
  },
  {
    query: 'Guam',
    suggestions: ['fanghi', 'leggings', 'crema', 'pancia', 'duo'],
  },
]
